import { useCallback } from 'react';
import { useStore } from 'react-redux';

import { resolveActiveGate } from './label-purchase-gate';

export const useLabelPurchaseGate = () => {
  const store = useStore();
  return useCallback(
    (fulfillmentPlanIds: string[], onSuccess: () => void, onCancel?: () => void, sellerLabelProviderIds?: string[]) => {
      const gate = resolveActiveGate({ state: store.getState(), fulfillmentPlanIds, sellerLabelProviderIds });
      if (!gate) {
        onSuccess();
        return;
      }
      gate.launchModal(onSuccess, onCancel);
    },
    [store],
  );
};
